import cn from "classnames"
import { useCallback } from "react"
import { useNavigate } from "react-router-dom"
import usePreRender from "hooks/usePreRender"
import { Tooltip } from "components/Core"
import { ReactNode } from "react"

interface IButtonGroup {
  disabled?: boolean
  onSubmit?: () => void
  isLoading?: boolean
  cancelText?: string
  saveText?: string
  savingText?: string
  saveIcon?: ReactNode
  cancelIcon?: ReactNode
  showCancel?: boolean
}

const ButtonGroup = ({
  disabled = false,
  onSubmit,
  isLoading = false,
  cancelText = "Cancelar",
  saveText = "Guardar",
  savingText = "Guardando...",
  saveIcon,
  cancelIcon,
  showCancel = true,
}: IButtonGroup) => {
  const { _color } = usePreRender()
  const navigate = useNavigate()

  const handle_back = useCallback(() => navigate(-1), [navigate])
  const handle_save = useCallback(() => {
    if (onSubmit) onSubmit()
  }, [onSubmit])

  return (
    <div className="flex flex-row gap-2 font-semibold">
      {/* Botón Cancelar */}
      {showCancel && (
        <Tooltip content={cancelText} align="top">
          <button
            type="button"
            onClick={handle_back}
            className={cn(
              "p-2 text-sm border hover:opacity-80 rounded-md shadow-sm hover:shadow-md transform transition duration-500 hover:scale-105 flex items-center justify-center min-w-[40px]",
              `border_${_color}`,
              `text_${_color}`,
              !cancelIcon && "w-full lg:w-48",
            )}
          >
            {cancelIcon ? cancelIcon : cancelText}
          </button>
        </Tooltip>
      )}

      {/* Botón Guardar */}
      <Tooltip content={isLoading ? savingText : saveText} align="top">
        <button
          disabled={disabled || isLoading}
          type={onSubmit ? "button" : "submit"}
          onClick={handle_save}
          className={cn(
            "p-2 text-sm text-white rounded-md shadow-sm hover:shadow-md transform transition duration-500 hover:scale-105 flex items-center justify-center min-w-[40px]",
            {
              [`bg_${_color}`]: !disabled && !isLoading,
              "bg-slate-500": disabled || isLoading,
              "hover:opacity-80": !disabled && !isLoading,
              "w-full lg:w-48": !saveIcon,
            },
          )}
          aria-disabled={disabled || isLoading}
        >
          {isLoading ? (
            <div className="flex items-center gap-2">
              <span className="h-3 w-3 border-2 border-white/30 border-t-white rounded-full animate-spin"></span>
              {!saveIcon && savingText}
            </div>
          ) : (
            saveIcon ? saveIcon : saveText
          )}
        </button>
      </Tooltip>
    </div>
  )
}

export default ButtonGroup
